import {
  doGetExternalAppRequest,
  doPostExternalAppRequest,
} from "./ApiService";
import { baseHeaders } from "./Headers";
import store from "@/store";

export function validateCoupon(): Promise<any> {
  const url = "/coupon/purchase-order/"
    .concat(store.getters.customer.purchaseOrderId)
    .concat("/coupon")
    .concat(`?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`);
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-recaptcha": localStorage.getItem("captcha")!,
  };
  const data = {
    code: store.getters.coupon.code,
  };
  return doPostExternalAppRequest(url, data, headers);
}

export function checkCupom(payload: any): Promise<any> {
  const url = "/coupon/"
    .concat(payload.cupom)
    .concat("/catalogOffer/")
    .concat(payload.catalogOfferId)
    .concat(`?gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`);
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-recaptcha": localStorage.getItem("captcha")!,
  };
  return doGetExternalAppRequest(url, headers);
}
